import { render, staticRenderFns } from "./VacanciesListDetailListItem.vue?vue&type=template&id=d64db3a4&scoped=true&"
import script from "./VacanciesListDetailListItem.vue?vue&type=script&lang=js&"
export * from "./VacanciesListDetailListItem.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesListDetailListItem.vue?vue&type=style&index=0&id=d64db3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64db3a4",
  null
  
)

export default component.exports